<template>
  <div class="container page-guide">
    <div class="row p-sm bg-color-login">
      <div class="col-md-12">
        <div class="text-center">
          <div class="title">
            <h4>ご利用ありがとうございます。</h4>
          </div>
          <div class="content">
            <h4>Amazonとの連携に関しては
              <a class="text--underline" :href="downloadUrl" download target="_blank"><span>こちら</span></a>
            をご参照ください</h4>
          </div>
        </div>
        <div class="back">
          <button @click="toHome" class="btn btn-warning btn-block">セールモンスターを始める</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      downloadUrl: `${process.env.NODE_DOMAIN}/static/dists/pdf/ServiceOverview.pdf`
    }
  },
  methods: {
    toHome () {
      this.$router.push('/signup')
    }
  }
}
</script>

<style scoped>
.container {
  max-width: 620px;
  margin: auto;
  padding-top: 20rem;
}

.title {
  margin-top: 32px
}
</style>



// WEBPACK FOOTER //
// src/view/Guide.vue